module.exports = __webpack_public_path__ + "img/money-card.7ef65850.svg";